<template>
    <v-content class="pa-12">
        <v-layout justify-space-around>
            <v-flex d-flex justify-start align-center style="color: #3E7662;font-weight: bold;font-size: 24px;">
                <span>จัดการแหล่งทุนวิจัย</span>
            </v-flex>
        </v-layout>
        <v-layout justify-space-around mt-6>
            <v-flex d-flex justify-end align-center>
                <v-btn color="#3E7662" dark @click="createBudgetModal">
                    <span class="mr-2">เพิ่มแหล่งทุนวิจัย</span>
                    <v-icon>add_box</v-icon>
                </v-btn>
            </v-flex>
        </v-layout>
        <!-- Table -->
        <v-layout mt-8>
            <v-flex>
                <form-table
                        v-if="reload"
                        :headers="headers"
                        :items="budgetList"
                        on-edit-budget
                        on-delete-budget
                        :onClickDeleteBudget="deleteBudget"
                        :onReload="reload"
                        :editBudget="editBudget"
                ></form-table>
            </v-flex>
        </v-layout>
        <!-- Pagination -->
        <v-layout mt-12>
            <v-flex>
                <v-pagination
                        color="#3E7662"
                        :length="paginateBudgetResource.last_page"
                        :total-visible="9"
                        @input="getBudgetResourceList"
                        v-model="paginateBudgetResource.current_page"
                ></v-pagination>
            </v-flex>
        </v-layout>

        <!--create new budget modal-->
        <template>
            <v-row justify="center">
                <v-dialog v-model="budgetDialog" persistent max-width="600px">
                    <v-card>
                        <!-- Header -->
                        <v-card-title class="mb-4">
                            <span style="font-weight: bold">เพิ่มแหล่งทุนวิจัย</span>
                        </v-card-title>
                        <v-card-text>
                            <!-- row 1 -->
                            <v-layout px-6>
                                <v-flex xs3 mr-3 justify-end align-center d-flex>
                                    <span style="font-weight: bold;">ชื่อแหล่งทุนวิจัย</span>
                                </v-flex>
                                <v-flex justify-start align-center d-flex>
                                    <v-text-field
                                        color="#3E7662"
                                            v-model="budgetForm.budgetResource"
                                            outlined
                                            dense
                                            hide-details
                                    />
                                </v-flex>
                            </v-layout>
                            <!-- row 2 -->
                            <v-layout mt-6 px-6>
                                <v-flex xs3 mr-3 justify-end align-center d-flex>
                                    <span style="font-weight: bold;">ประเภทแหล่งทุนวิจัย </span>
                                </v-flex>
                                <v-flex xs9 pt-4 class="field-select">
                                    <v-select
                                            clearable
                                            :menu-props="{ bottom: true, offsetY: true }"
                                            background-color="#3E7662"
                                            solo
                                            flat
                                            dense
                                            label="ภายใน/ภายนอก"
                                            :items="budgetType"
                                            item-text="name"
                                            item-value="id"
                                            v-model="budgetForm.isInside"
                                    ></v-select>

                                </v-flex>
                            </v-layout>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn style="font-weight: bold" color="#3E7662" text @click="budgetDialog = false">ยกเลิก</v-btn>
                            <v-btn style="font-weight: bold" color="#3E7662" text @click="createBudget">บันทึก</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>
        </template>
        <!-- budget modal-->
        <template>
            <v-row justify="center">
                <v-dialog v-model="budgetDialog2" persistent max-width="600px">
                    <v-card style="background-color: #FAF5F2">
                        <!-- Header -->
                        <v-card-title class="mb-4">
                            <span>แก้ไขแหล่งทุนวิจัย</span>
                        </v-card-title>
                        <v-card-text>
                            <!-- row 1 -->
                            <v-layout px-6>
                                <v-flex xs3 mr-3 justify-end align-center d-flex>
                                    <span style="font-weight: bold;">ชื่อแหล่งทุนวิจัย</span>
                                </v-flex>
                                <v-flex justify-start align-center d-flex>
                                    <v-text-field
                                            color="#3E7662"
                                            v-model="budgetForm.budgetResource"
                                            outlined
                                            dense
                                            hide-details
                                    />
                                </v-flex>
                            </v-layout>
                            <!-- row 2 -->
                            <v-layout mt-6 px-6>
                                <v-flex xs3 mr-3 justify-end align-center d-flex>
                                    <span style="font-weight: bold;">ประเภทแหล่งทุนวิจัย </span>
                                </v-flex>
                                <v-flex xs9 pt-4 class="field-select">
                                    <v-select
                                            clearable
                                            :menu-props="{ bottom: true, offsetY: true }"
                                            background-color="#3E7662"
                                            solo
                                            flat
                                            dense
                                            label="ภายใน/ภายนอก"
                                            :items="budgetType"
                                            item-text="name"
                                            item-value="id"
                                            v-model="budgetForm.isInside"
                                    ></v-select>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                        <v-card-actions class="mr-12 pb-6">
                            <v-spacer></v-spacer>
                            <v-btn style="font-weight: bold" class="mr-2" color="#fff" @click="budgetDialog2 = false"><span style="color: #3e7662">ยกเลิก</span></v-btn>
                            <v-btn style="font-weight: bold" color="#3E7662" dark @click="updateBudget">บันทึก</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>
        </template>

        <loading
                color="#527281"
                :active.sync="isLoading"
                :can-cancel="false"
                :is-full-page="fullPage"
        ></loading>

    </v-content>
</template>

<script>
    import FormTable from "../../components/table/FormTable";
    import Loading from 'vue-loading-overlay';
    import 'vue-select/dist/vue-select.css';
    import Swal from 'sweetalert2';
    import { mapState, mapActions } from "vuex";
    export default {
        name: "BudgetResource",
        components: {
            FormTable,
            Loading,
        },
        computed: {
            years () {
                this.year = new Date().getFullYear();
                return Array.from({length: this.year - 1900 }, (value, index) => (1901+543) + index).reverse();
            },
            ...mapState({
                user: state => state.Auth.user
            })
        },
        data: () => ({
            reload: true,
            isLoading: false,
            fullPage: true,
            budgetDialog: false,
            budgetDialog2: false,
            // budgetForm:[],
            budgetList:[],
            paginateBudgetResource: {
                current_page: 1,
                from: 1,
                last_page: 1,
                per_page: 1,
                total: 1,
                to: 1
            },
            headers: [
                {text: 'ลำดับ', value: 'number', align: "center"},
                { text: 'ชื่อแหล่งทุนวิจัย', value: 'budgetResource', align: "center" },
                { text: 'ประเภทแหล่งทุน ภายใน/ภายนอก', value: 'isInside', align: "center" },
                { text: 'จัดการ', value: 'editBudget', align: "center",},
                { text: 'ลบ', value: 'deleteBudget', align: "center",},
            ],
            budgetType:[
                {
                    id:0,
                    name:'แหล่งทุนวิจัยภายนอก',
                },
                {
                    id:1,
                    name:'แหล่งทุนวิจัยภายใน',
                },
            ],
            budgetForm: {
                id:'',
                budgetResource:'',
                isInside:'',
            },
        }),
        created(){
            // Check Permission Access
          //  if (this.user.currentRole !== 1) {
          //      this.$router.go(-1);
          //  }

            this.getBudgetResourceList(1);
        },
        methods: {
            getBudgetResourceList(page)
            {
                this.isLoading = true;
                this.budgetList = [];
                this.$store.dispatch('Budget/getBudgetResourceList',page).then(res => {
                    let i = 1;
                    res.data.forEach(data => {
                        this.budgetList.push({
                            number: i,
                            id: data.id,
                            budgetResource: data.budgetResource,
                            isInside: data.isInside === 0 ? 'แหล่งทุนวิจัยภายนอก':'แหล่งทุนวิจัยภายใน',
                            linkEdit: 'EditBudgetResource',
                            deleteBudget: data.id,
                        });
                        i++;
                    })
                    this.paginateBudgetResource.current_page = res.current_page;
                    this.paginateBudgetResource.from = res.from;
                    this.paginateBudgetResource.last_page = res.last_page;
                    this.paginateBudgetResource.per_page = res.per_page;
                    this.paginateBudgetResource.total = res.total;
                    this.paginateBudgetResource.to = res.to;
                    this.isLoading = false;
                }).catch(e => {
                    this.isLoading = false;
                })
            },
            createBudgetModal(){
                this.budgetDialog = true;
            },
            createBudget(){
                this.isLoading = true;
                let data ={
                    budgetResource: this.budgetForm.budgetResource,
                    isInside: this.budgetForm.isInside,
                }
                this.$store.dispatch('Budget/createBudget',data).then(res => {

                    this.isLoading = false;
                    Swal.fire({
                        title: "เพิ่มแหล่งทุนวิจัยเสร็จสิ้น",
                        icon: 'success',
                        position: 'center',
                        showConfirmButton: false,
                        timer: 1500
                    }).then(() => {
                      this.budgetDialog = false;
                      this.getBudgetResourceList(1);
                      // window.location.reload();
                    });
                }).catch(e => {
                    Swal.fire({
                        title: "เกิดข้อผิดพลาด",
                        text: "บันทึกไม่สำเร็จ",
                        icon: 'warning'
                    });
                });
            },
            editBudget(item) {
                this.budgetForm.id = item.id;
                this.budgetForm.budgetResource = item.budgetResource;
                this.budgetForm.isInside = item.isInside === 'แหล่งทุนวิจัยภายใน'? 1 : ''|| item.isInside === 'แหล่งทุนวิจัยภายนอก' ? 0 : '';
                this.budgetDialog2 = true;
            },
            updateBudget() {
                let data = {
                    id: this.budgetForm.id,
                    budgetResource: this.budgetForm.budgetResource,
                    isInside: this.budgetForm.isInside,
                };
                this.isLoading = true;
                this.$store.dispatch('Budget/updateBudget', data).then(res => {
                    this.isLoading = false;
                    Swal.fire({
                        title: "อัพเดตเรียบร้อยแล้ว",
                        icon: 'success',
                        position: 'center',
                        showConfirmButton: false,
                        timer: 1500,
                    }).then(()=>{
                        this.budgetDialog = false;
                        this.getBudgetResourceList(1);
                    })
                }).catch(e => {
                    this.isLoading = false;
                    Swal.fire({
                        title: "เกิดข้อผิดพลาด",
                        text: "บันทึกไม่สำเร็จ",
                        icon: 'warning'
                    });
                })
            },
            deleteBudget(id) {
                // console.log(this.budgetList);
                // console.log(id);
                Swal.fire({
                    title: 'คุณต้องการลบข้อมูลหรือไม่?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3E7662',
                    cancelButtonColor: 'rgb(189, 189, 189)',
                    confirmButtonText: 'ต้องการ',
                }).then((result) => {
                    if (result.value) {
                        console.log(id)
                        this.$store.dispatch('Budget/deleteBudget',id).then(() => {
                            Swal.fire({
                                title: "ลบข้อมูลเรียบร้อยแล้ว",
                                icon: 'success',
                                position: 'center',
                                showConfirmButton: false,
                                timer: 1500
                            }).then(() => {
                              this.getBudgetResourceList(this.paginateBudgetResource.current_page)
                            });
                        }).catch(e => {
                            Swal.fire({
                                title: "เกิดข้อผิดพลาด",
                                text: "บันทึกไม่สำเร็จ",
                                icon: 'warning'
                            });
                        })
                    }
                })
            },
        }
    }
</script>

<style lang="scss">
    table th + th { border-left: 1px solid #dddddd; }
    table td + td { border-left: 1px solid #dddddd; }
    .table {
        th.text-center.sortable {
            font-weight: bold;
            font-size: 16px;
        }
    }
    .table {
        th.text-left.sortable {
            font-weight: bold;
            font-size: 16px;
        }
    }
    table thead tr th{
        text-align: center!important;
    }
    tbody tr td {
        color: #544A44;
    }
    table tbody tr td {
        text-align: left!important;
    }
    thead.v-data-table-header tr th {
        span {
            color: #000;
            font-size: 14px;
        }
    }
</style>

